import React from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import "./standard.scss";
import Loader from "../../common/Loader";
function StandardTarrif() {
  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["companyProfileData"],
    queryFn: () =>
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/page/detail/standard-tariff-charges`
        )
        .then((res) => res.data),
  });
  if (isLoading || isFetching) return <Loader />;
  if (error) return <div>An error has occurred: {error.message}</div>;
  const pdfUrl = `https://admin.icfcbank.com/uploads/content/${data?.detail?.en?.DocPath}`;

  return (
    <div className="pdf-page">
      {pdfUrl ? (
        <>
          {/* PDF in iframe - viewer only, no controls */}
          <iframe
            src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
            title="Standard Tariff Charges PDF document"
            aria-label="Standard Tariff Charges PDF document"
            width="100%"
            height="800px"
            style={{ border: "none" }}
          />

          {/* Custom Download Button */}
          <div className="download-container">
            <a href={pdfUrl} download target="_blank" rel="noopener noreferrer">
              <button className="download-button">Download PDF</button>
            </a>
          </div>
        </>
      ) : (
        <p>No PDF available.</p>
      )}
    </div>
  );
}

export default StandardTarrif;
